import {ButtonProps} from "@FRAMEWORK/ui/types/d";
import styled, {css} from "@yb/styled-px2rem";

interface IProps extends ButtonProps {
	types: "plus" | "minus";
	// disabled?: boolean;
}

const StyledButton = styled.button<IProps>`
	position: relative;
	width: 40px;
	height: 40px;
	border: 1px solid var(--bl-color);
	background-color: #fff;
	color: var(--emp-color);

	${props => {
		if (props.types === "plus") {
			return css`
				:before {
					position: absolute;
					top: 50%;
					left: 50%;
					display: block;
					width: 2px;
					height: 18px;
					background-color: var(--emp-color);
					transform: translate(-50%, -50%);
					content: "";
				}
				:after {
					position: absolute;
					top: 50%;
					left: 50%;
					display: block;
					width: 18px;
					height: 2px;
					background-color: var(--emp-color);
					transform: translate(-50%, -50%);
					content: "";
				}
			`;
		}
		if (props.types === "minus") {
			return css`
				:before {
					position: absolute;
					top: 50%;
					left: 50%;
					display: block;
					width: 18px;
					height: 2px;
					background-color: var(--emp-color);
					transform: translate(-50%, -50%);
					content: "";
				}
				&[type="button"]:disabled {
					background: #eee;
					color: var(--gray-color);
					cursor: unset;
				}
			`;
		}
	}}

	&[type="button"]:disabled {
		background-color: #fff;

		&:before {
			background-color: var(--line-color);
		}

		&:after {
			background-color: var(--line-color);
		}
	}
`;

const NumberButton = ({types = "minus", disabled = false, color = "basic", ...props}: IProps) => (
	<StyledButton type="button" disabled={disabled} types={types} color={color} {...props}></StyledButton>
);

export default NumberButton;
